import { Component, Input } from '@angular/core';

@Component({
  selector: 'axis-card',
  templateUrl: './card.component.html',
  host: {
    class: 'axis-card'
  }
})
export class CardComponent {
  @Input() inverse = '';
  @Input() kind = '';
}

@Component({
  selector: 'axis-card-img-container',
  template: '<ng-content></ng-content>',
  host: {
    class: 'axis-card-img-container'
  }
})
export class CardImgContainerComponent {}

@Component({
  selector: 'axis-card-row',
  template: '<ng-content></ng-content>',
  host: {
    class: 'axis-card-row'
  }
})
export class CardRowComponent {}

@Component({
  selector: 'axis-card-body',
  template: '<ng-content></ng-content>',
  host: {
    class: 'axis-card-body'
  }
})
export class CardBodyComponent {}

@Component({
  selector: 'axis-card-heading',
  template: '<ng-content></ng-content>',
  host: {
    class: 'axis-card-heading'
  }
})
export class CardHeadingComponent {}

@Component({
  selector: 'axis-card-footer',
  template: '<ng-content></ng-content>',
  host: {
    class: 'axis-card-footer'
  }
})
export class CardFooterComponent {}

@Component({
  selector: 'axis-card-spotlight-container',
  template: '<ng-content></ng-content>',
  host: {
    class: 'axis-card-spotlight-container'
  }
})
export class CardSpotlightContainerComponent {
  @Input() alignflexitems = '';
}

@Component({
  selector: 'axis-card-content',
  template: '<ng-content></ng-content>',
  host: {
    class: 'axis-card-content'
  }
})
export class CardContentComponent {
  @Input() cardcontent = '';
}

@Component({
  selector: 'axis-card-heading-body',
  template: '<ng-content></ng-content>',
  host: {
    class: 'axis-card-heading-body'
  }
})
export class CardHeadingBodyComponent {}

@Component({
  selector: 'axis-card-heading-right',
  template: '<ng-content></ng-content>',
  host: {
    class: 'axis-card-heading-right'
  }
})
export class CardHeadingBodyRightComponent {}

@Component({
  selector: 'axis-card-group',
  template: '<ng-content></ng-content>',
  host: {
    class: 'axis-card-group'
  }
})
export class CardGroupComponent {}

@Component({
  selector: 'axis-card-img-overlay',
  template: '<ng-content></ng-content>',
  host: {
    class: 'axis-card-img-overlay'
  }
})
export class CardImgOverlayComponent {}

@Component({
  selector: 'axis-card-ribbon',
  template: ' <label [attr.data-bg]="backgroundColor"><ng-content></ng-content></label>',
  host: {
    class: 'axis-ribbon'
  }
})
export class CardRibbonComponent {
  @Input() backgroundColor ='';
}

@Component({
  selector: 'axis-card-ribbon-icon',
  template: 
  `<div class="axis-ribbon axis-ribbon-icon" [attr.data-bg]="backgroundColor">
    <axis-icon icon="{{icon}}" font="{{font}}"></axis-icon>
   </div>`
})
export class CardRibbonIconComponent {
  @Input() icon ='';
  @Input() font ='custom';
  @Input() backgroundColor ='';
}
